import React, { useCallback, useRef, useState } from "react";
import { so_logo } from "../icons";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const Navbar = () => {
	const dropdownRef = useRef(null);
	const pathname = useLocation().pathname;
	const goalsPath = pathname.includes("goal") || pathname.includes("archive");
	const canAccessGoals = useSelector((state: any) => state.authenticateuser.data.features?.includes("goals"));
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const toggleDropdown = useCallback(() => setDropdownOpen(!dropdownOpen), [dropdownOpen]);
	return (
		<nav className="navbar navbar-expand-lg admin-navbar">
			<Link className="navbar-brand" to="/admin">
				{so_logo}
			</Link>
			{/*<a className="navbar-brand" href="#">{so_logo}</a>*/}
			{canAccessGoals && (
				<div className="dropdown">
					<button onClick={toggleDropdown}>
						{goalsPath ? "GOALS" : "DASHBOARDS"}
						<span>▼</span>
					</button>
					{dropdownOpen && (
						<div className="dropdown_menu" ref={dropdownRef}>
							{goalsPath ? (
								<Link to="/admin" onClick={toggleDropdown}>
									DASHBOARDS
								</Link>
							) : (
								<Link to="/admin/goals" onClick={toggleDropdown}>
									GOALS
								</Link>
							)}
						</div>
					)}
				</div>
			)}
		</nav>
	);
};

export default Navbar;
